import { m } from 'framer-motion';

const technologies = [
  { name: 'Docker', category: 'DevOps' },
  { name: 'Kubernetes', category: 'DevOps' },
  { name: 'GitLab CI', category: 'DevOps' },
  { name: 'Linux', category: 'OS' },
  { name: 'Ubuntu', category: 'OS' },
  { name: 'Debian', category: 'OS' },
  { name: 'Windows Server', category: 'OS' },
  { name: 'Python', category: 'Backend' },
  { name: 'Django', category: 'Backend' },
  { name: 'FastAPI', category: 'Backend' },
  { name: 'Go', category: 'Backend' },
  { name: 'PostgreSQL', category: 'Database' },
  { name: 'Redis', category: 'Database' },
  { name: 'MikroTik', category: 'Network' },
  { name: 'Cisco', category: 'Network' },
  { name: 'Zabbix', category: 'Monitoring' },
  { name: 'Bitrix24', category: 'CRM' },
  { name: 'amoCRM', category: 'CRM' },
];

// Удваиваем массив для бесшовной бесконечной прокрутки
const doubledTechs = [...technologies, ...technologies];

export const TechStack = () => {
  return (
    <section className="py-16 bg-[#020617] border-t border-b border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <m.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="text-2xl font-bold text-white mb-2">Технологии, с которыми мы работаем</h2>
          <p className="text-slate-500">Наш стек для реализации проектов любой сложности</p>
        </m.div>
      </div>

      <div className="relative flex overflow-x-hidden">
        {/* Градиентные маски по краям для плавного исчезновения */}
        <div className="absolute top-0 bottom-0 left-0 w-32 bg-gradient-to-r from-[#020617] to-transparent z-10"></div>
        <div className="absolute top-0 bottom-0 right-0 w-32 bg-gradient-to-l from-[#020617] to-transparent z-10"></div>

        <div className="animate-marquee flex whitespace-nowrap items-center py-4">
          {doubledTechs.map((tech, index) => (
            <div 
              key={index}
              className="mx-4 px-6 py-3 glass-panel rounded-xl border border-white/5 flex items-center gap-3 hover:border-accent/50 hover:bg-white/10 transition-colors cursor-default"
            >
              <span className="text-white font-bold">{tech.name}</span>
              <span className="text-xs text-accent bg-accent/10 px-2 py-0.5 rounded-md font-medium uppercase tracking-wider">
                {tech.category}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};